import React, { type PropsWithChildren } from 'react';
import { StyleSheet, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useStyle } from 'react-native-style-utilities';
import { theme } from '@garnish/constants';

import { backgroundPalettes, type ScanToPayPalette } from '../../utils';

export const ScanToPayFooter = (props: ScanToPayFooterProps) => {
  const { palette, children } = props;

  const { bottom } = useSafeAreaInsets();
  const paddingBottom = useStyle(
    () => ({ paddingBottom: Math.max(bottom, theme.spacing['10']) }),
    [bottom],
  );

  return (
    <View
      style={[styles.container, paddingBottom, backgroundPalettes[palette]]}
    >
      {children}
    </View>
  );
};

// ─── Types ───────────────────────────────────────────────────────────────────

type ScanToPayFooterProps = PropsWithChildren & {
  palette: ScanToPayPalette;
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    backgroundColor: theme.colors.CREAM,
    left: 0,
    right: 0,
    bottom: 0,
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing['4'],
    padding: theme.spacing['4'],
  },
});
